/**
 * HiNUtS Pack-Auswahl
 * =============================================================================
 * Mehrfach-Packs (24er, 48er, 96er …) sind nur Stellvertreter-Produkte.
 * Klickt jemand bei so einem Pack auf „In den Warenkorb", öffnet sich ein Popup,
 * in dem die Sorten frei gewählt werden. In den Warenkorb kommen danach nur die
 * echten 12er-Boxen – optional als Appstle-Abo.
 *
 * Erkennung eines Packs:  Produkt-Tag „pack-N"  (N = Anzahl 12er-Boxen)
 * Datenquelle:            <script id="HinutsPackData"> aus sections/hinuts-pack-picker.liquid
 * Styles:                 assets/hinuts-pack-picker.css
 *
 * Aufbau dieser Datei
 *   1. Konfiguration & Helfer (inkl. Mengenrabatt-Staffeln)
 *   2. Appstle-Abo (Selling Plans)
 *   3. Shopify-Warenkorb
 *   4. Popup (PackPicker)
 *   5. Produktkarten: Preise, Badges, „In den Warenkorb"-Button
 *   6. Produktseite einer Box oder eines Packs
 *   7. Sale-Code für alle + Hinweis „Code aktiviert"
 *   8. Start
 */
(() => {
  'use strict';

  if (window.HinutsPack) return; // nur einmal pro Seite initialisieren

  /* ---------------------------------------------------------------------------
   * 1. Konfiguration & Helfer
   * ------------------------------------------------------------------------ */

  const dataEl = document.getElementById('HinutsPackData');
  if (!dataEl) return;

  let config;
  try {
    config = JSON.parse(dataEl.textContent);
  } catch (error) {
    console.warn('[HiNUtS Pack] Konfiguration fehlerhaft', error);
    return;
  }

  const texts = config.texts || {};
  const boxes = (config.boxes || []).filter((box) => box && box.variantId);
  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /** Cent-Betrag im Shop-Format, z. B. 14352 → „€143,52". */
  function formatMoney(cents) {
    const format = config.moneyFormat || '€{{amount_with_comma_separator}}';
    const value = Math.round(cents) / 100;
    const group = (digits, separator) => digits.replace(/\B(?=(\d{3})+(?!\d))/g, separator);
    const [whole, decimals] = value.toFixed(2).split('.');

    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount': return `${group(whole, ',')}.${decimals}`;
        case 'amount_no_decimals': return group(String(Math.round(value)), ',');
        case 'amount_no_decimals_with_comma_separator': return group(String(Math.round(value)), '.');
        default: return `${group(whole, '.')},${decimals}`; // amount_with_comma_separator
      }
    });
  }

  function escapeHtml(value) {
    const map = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
    return String(value == null ? '' : value).replace(/[&<>"']/g, (char) => map[char]);
  }

  /** Tag „pack-4" → 4. Kein Pack → 0. */
  function packSizeFromTags(tags) {
    let size = 0;
    (tags || []).forEach((tag) => {
      const match = /pack-(\d+)/.exec(String(tag).toLowerCase());
      if (match) size = parseInt(match[1], 10);
    });
    return size;
  }

  /** Bundle-Builder-Produkte (Produkttyp „bundle") brauchen ihre eigene Produktseite. */
  function isBundleBuilder(product) {
    return String(product.type || '').toLowerCase().trim() === 'bundle';
  }

  /* ---------------------------------------------------------------------------
   * Mengenrabatt (Anzeige)
   *
   * Abgezogen wird der Rabatt im Warenkorb von Kaching (Bestellrabatt nach Anzahl
   * Boxen). Hier zeigen wir ihn nur an – die Staffeln kommen aus der Section-
   * Einstellung „Mengenrabatt-Staffeln" und müssen mit Kaching übereinstimmen.
   * ------------------------------------------------------------------------ */

  /** „2:3, 4:10, 8:15" → [{ minBoxes: 2, percent: 3 }, …] aufsteigend sortiert */
  const volumeTiers = String(config.volumeTiers || '')
    .split(',')
    .map((part) => {
      const [minBoxes, percent] = part.split(':').map((value) => parseFloat(value));
      return { minBoxes, percent };
    })
    .filter((tier) => tier.minBoxes > 0 && tier.percent > 0)
    .sort((a, b) => a.minBoxes - b.minBoxes);

  /** Höchste Staffel, die bei dieser Anzahl Boxen greift (in %). */
  function volumeDiscountPercent(boxCount) {
    let percent = 0;
    volumeTiers.forEach((tier) => { if (boxCount >= tier.minBoxes) percent = tier.percent; });
    return percent;
  }

  /* ---------------------------------------------------------------------------
   * Rabattcode aus Link (Anzeige)
   *
   * Kommt jemand über hinuts.com/discount/TRY15, merkt sich Shopify den Code im
   * Cookie „discount_code" und zieht ihn an der Kasse ab. Wie viel Prozent ein
   * Code bringt, kann der Shop im Browser nicht auslesen – deshalb stehen die
   * Codes in der Section-Einstellung „Rabattcodes für die Preisanzeige".
   * Annahme: Codes gelten nur für einmalige Käufe (nicht im Abo).
   * ------------------------------------------------------------------------ */

  /** „TRY15:15, HERBST10:10" → Map { 'TRY15' → 15, 'HERBST10' → 10 } */
  const knownCodes = new Map(
    String(config.displayCodes || '')
      .split(',')
      .map((part) => part.split(':').map((value) => value.trim()))
      .filter(([code, percent]) => code && parseFloat(percent) > 0)
      .map(([code, percent]) => [code.toUpperCase(), parseFloat(percent)])
  );

  /** Sale-Code für alle (z. B. BLACKWEEK) – aus der Section-Einstellung, sonst null. */
  const saleCode = config.saleCode && config.saleCode.code ? config.saleCode : null;
  if (saleCode) knownCodes.set(saleCode.code, saleCode.percent);

  /**
   * Welche Codes gerade gelten. Wichtigste Quelle ist der Warenkorb: Dort landet
   * ein Code auch, wenn ihn der Kunde im Kaching-Warenkorb eintippt (dann gibt es
   * kein Cookie). Cookie bzw. ?discount= aus dem Link sind der Rückfall – z. B.
   * solange der Warenkorb noch leer ist.
   */
  const codeState = {
    cartCodes: null,          // null = Warenkorb noch nicht geladen; sonst gültige Codes in GROSSBUCHSTABEN
    cartPercents: new Map(),  // Code → Prozent, so wie Shopify ihn im Warenkorb gerade abzieht

    async load() {
      try {
        const response = await fetch(`${ROOT}cart.js`, { headers: { Accept: 'application/json' } });
        const cart = await response.json();
        this.cartCodes = (cart.discount_codes || [])
          // Bei leerem Warenkorb ist kein Code „anwendbar“ – dann trotzdem zählen
          .filter((entry) => entry.applicable || !cart.item_count)
          .map((entry) => String(entry.code).trim().toUpperCase());

        // Prozentsatz direkt aus dem Warenkorb lesen – so stimmt die Anzeige für JEDEN
        // Prozent-Code (TRY15, HI-…, Sale-Code), ohne dass er irgendwo eingetragen sein muss.
        this.cartPercents = new Map();
        const applications = [
          ...(cart.cart_level_discount_applications || []),
          ...(cart.items || []).flatMap((item) =>
            (item.line_level_discount_allocations || []).map((allocation) => allocation.discount_application)),
        ];
        applications.forEach((application) => {
          if (!application || application.type !== 'discount_code' || application.value_type !== 'percentage') return;
          this.cartPercents.set(String(application.title).trim().toUpperCase(), parseFloat(application.value));
        });
        this.rememberCart(cart);
      } catch (error) {
        this.cartCodes = null; // Warenkorb nicht lesbar → nur Cookie/Link verwenden
      }
    },

    /** Kurzer Fingerabdruck, um zu erkennen, ob sich der Code geändert hat. */
    signature() {
      const active = activeDiscountCode();
      return `${this.codes().join(',')}|${active ? active.percent : ''}`;
    },

    /**
     * Warenkorb erneut prüfen und – nur wenn sich der Code geändert hat – alles neu
     * zeichnen. Wird nach Klicks/Eingaben aufgerufen, damit ein im Kaching-Warenkorb
     * getauschter Code sofort oben und bei den Preisen erscheint (ohne Neuladen).
     */
    async refresh() {
      if (this.refreshing) return this.refreshing;
      this.refreshing = (async () => {
        const before = this.signature();
        await this.load();
        if (this.signature() !== before) rerenderAll();
      })();
      try { await this.refreshing; } finally { this.refreshing = null; }
    },

    /** Alle Codes, die gerade gelten (Warenkorb vor Cookie/Link). */
    codes() {
      if (this.cartCodes && this.cartCodes.length) return this.cartCodes;
      const cookie = /(?:^|;\s*)discount_code=([^;]*)/.exec(document.cookie);
      const fromUrl = new URLSearchParams(window.location.search).get('discount');
      const codes = decodeURIComponent((cookie && cookie[1]) || fromUrl || '')
        .split(',')
        .map((code) => code.trim().toUpperCase())
        .filter(Boolean);

      // Code stand schon im Warenkorb und wurde dort entfernt → nicht mehr anzeigen,
      // auch wenn das Cookie noch da ist.
      const removed = this.removedCodes();
      return codes.filter((code) => !removed.includes(code));
    },

    /**
     * Merker im Browser: welche Codes der Warenkorb schon einmal hatte. Fehlt so ein
     * Code später im (gefüllten) Warenkorb, hat der Kunde ihn entfernt.
     */
    rememberCart(cart) {
      const seen = new Set(readStore('hnp-cart-codes', []));
      this.cartCodes.forEach((code) => seen.add(code));
      writeStore('hnp-cart-codes', [...seen].slice(-10));

      // Neuer Code-Link (Cookie hat sich geändert) → diesen Code wieder zulassen
      const cookie = (/(?:^|;\s*)discount_code=([^;]*)/.exec(document.cookie) || [])[1] || '';
      let removed = this.removedCodes();
      if (cookie !== readStore('hnp-last-cookie', '')) {
        const fresh = decodeURIComponent(cookie).split(',').map((code) => code.trim().toUpperCase());
        removed = removed.filter((code) => !fresh.includes(code));
        writeStore('hnp-last-cookie', cookie);
      }

      if (cart.item_count) {
        removed = [...seen].filter((code) => !this.cartCodes.includes(code));
      }
      writeStore('hnp-removed-codes', removed);
    },

    removedCodes() {
      return readStore('hnp-removed-codes', []);
    },
  };

  function readStore(key, fallback) {
    try {
      const value = window.localStorage.getItem(key);
      return value ? JSON.parse(value) : fallback;
    } catch (error) {
      return fallback;
    }
  }

  function writeStore(key, value) {
    try { window.localStorage.setItem(key, JSON.stringify(value)); } catch (error) { /* privates Fenster o. Ä. */ }
  }

  /**
   * Aktiver Code mit Prozentsatz – z. B. { code: 'TRY15', percent: 15 } – oder null.
   * Prozent kommt aus dem Warenkorb; ist der noch leer, aus „Rabattcodes für die Preisanzeige“.
   */
  function activeDiscountCode() {
    for (const code of codeState.codes()) {
      const percent = codeState.cartPercents.get(code) || knownCodes.get(code);
      if (percent > 0) return { code, percent };
    }
    return null;
  }

  /**
   * Endpreis wie im Warenkorb berechnen.
   *   1. Abo-Rabatt (Appstle) pro Box, auf den Cent gerundet
   *   2. Rabattcode (Produktrabatt) pro Zeile, auf den Cent gerundet
   *   3. Mengenrabatt (Kaching-Bestellrabatt) auf die Zwischensumme
   * lines: [{ price, quantity }] – Preise in Cent
   */
  function priceBreakdown(lines, { boxCount, aboPercent = 0, codePercent = 0 }) {
    let fullPrice = 0;
    let subtotal = 0;

    lines.forEach(({ price, quantity }) => {
      fullPrice += price * quantity;
      let lineTotal = Math.round(price * (100 - aboPercent) / 100) * quantity;
      lineTotal -= Math.round(lineTotal * codePercent / 100);
      subtotal += lineTotal;
    });

    const volumePercent = volumeDiscountPercent(boxCount);
    const total = subtotal - Math.round(subtotal * volumePercent / 100);
    const totalPercent = fullPrice ? Math.round((1 - total / fullPrice) * 100) : 0;
    return { fullPrice, total, volumePercent, totalPercent };
  }

  /** Preis einer 12er-Box (alle Sorten kosten gleich viel). */
  const boxPrice = boxes.length ? boxes[0].price : 0;

  /* ---------------------------------------------------------------------------
   * 2. Appstle-Abo (Selling Plans)
   *
   * Appstle legt pro Lieferintervall eine Selling-Plan-Gruppe an, die für alle
   * Boxen gleich ist (gleiche Plan-ID). Die Option eines Plans kodiert die
   * Intervalle, z. B. „4WEEK4WEEKMIN_CYCLES=…" = Abrechnung alle 4 Wochen,
   * Lieferung alle 4 Wochen. Daraus lesen wir das Lieferintervall zum Sortieren.
   * ------------------------------------------------------------------------ */

  const DAYS_PER_UNIT = { DAY: 1, WEEK: 7, MONTH: 30, YEAR: 365 };

  /** Lieferintervall eines Plans in Tagen (für die Sortierung im Dropdown). */
  function deliveryIntervalDays(plan) {
    const appstle = /^(\d+)(DAY|WEEK|MONTH|YEAR)(\d+)(DAY|WEEK|MONTH|YEAR)/.exec(plan.option || '');
    if (appstle) return parseInt(appstle[3], 10) * DAYS_PER_UNIT[appstle[4]];

    const fallback = /(\d+)/.exec(plan.name || ''); // z. B. „alle 6 Wochen"
    return fallback ? parseInt(fallback[1], 10) * 7 : 0;
  }

  /**
   * Abo-Pläne, die ALLE übergebenen Boxen anbieten – sortiert nach Lieferintervall.
   * Nur gemeinsame Pläne sind sinnvoll, weil alle Boxen im selben Rhythmus kommen.
   */
  function sharedPlans(boxList) {
    if (!boxList.length) return [];
    return boxList[0].plans
      .filter((plan) => boxList.every((box) => box.plans.some((p) => p.id === plan.id)))
      .sort((a, b) => deliveryIntervalDays(a) - deliveryIntervalDays(b));
  }

  /* ---------------------------------------------------------------------------
   * 3. Shopify-Warenkorb (AJAX API)
   * ------------------------------------------------------------------------ */

  const productCache = new Map();

  const Cart = {
    /** Produktdaten aus /products/<handle>.js (zwischengespeichert). */
    getProduct(handle) {
      if (!productCache.has(handle)) {
        const request = fetch(`${ROOT}products/${handle}.js`, { headers: { Accept: 'application/json' } })
          .then((response) => {
            if (!response.ok) throw new Error('Produkt nicht gefunden');
            return response.json();
          })
          .catch((error) => {
            productCache.delete(handle);
            throw error;
          });
        productCache.set(handle, request);
      }
      return productCache.get(handle);
    },

    /** items: [{ id: Varianten-ID, quantity, selling_plan? }] */
    async add(items) {
      const response = await fetch(`${ROOT}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      });
      const result = await response.json();
      if (!response.ok || result.status) {
        throw new Error(result.description || result.message || 'Das hat leider nicht geklappt.');
      }
      return result;
    },

    /** Warenkorb öffnen – Kaching Cart bzw. AMP Slide Cart, falls aktiv, sonst Stiletto-Quick-Cart. */
    open() {
      if (window.kachingCartApi && typeof window.kachingCartApi.openCart === 'function') {
        window.kachingCartApi.openCart({ refetchCart: true }); // lädt den Warenkorb neu, inkl. Staffelrabatt
        return;
      }
      if (window.AMP_API && typeof window.AMP_API.OPEN_CART === 'function') {
        window.AMP_API.OPEN_CART();
        return;
      }
      document.dispatchEvent(new CustomEvent('apps:product-added-to-cart')); // Stiletto aktualisiert Zähler + Quick-Cart
      setTimeout(() => {
        const icons = [...document.querySelectorAll('[data-js-cart-icon]')];
        const icon = icons.find((el) => el.offsetParent !== null) || icons[0];
        if (icon) icon.click();
        else window.location.href = `${ROOT}cart`;
      }, 350);
    },
  };

  /* ---------------------------------------------------------------------------
   * 4. Popup (PackPicker)
   * ------------------------------------------------------------------------ */

  class PackPicker {
    constructor() {
      this.state = {
        size: 0,               // Anzahl Boxen im Pack
        quantities: new Map(), // Varianten-ID → Anzahl
        subscribe: false,      // Abo-Toggle
        planId: null,          // gewählter Appstle-Plan
        busy: false,
      };
      this.opener = null;
      this.build();
    }

    /* ----- Aufbau ----- */

    build() {
      this.overlay = document.createElement('div');
      this.overlay.className = 'hnp-overlay';
      this.overlay.setAttribute('aria-hidden', 'true');
      this.overlay.innerHTML = `
        <div class="hnp" role="dialog" aria-modal="true" aria-labelledby="hnp-title" tabindex="-1">
          <button type="button" class="hnp__close" data-action="close" aria-label="Schließen">&times;</button>

          <header class="hnp__head">
            <p class="hnp__eyebrow" data-ref="eyebrow"></p>
            <h2 class="hnp__title" id="hnp-title">${escapeHtml(texts.headline || 'Stell dir deine Boxen zusammen')}</h2>
            <p class="hnp__sub">${escapeHtml(texts.subline || '')}</p>
            <div class="hnp__progress">
              <div class="hnp__bar"><div class="hnp__bar-fill" data-ref="progress"></div></div>
              <span class="hnp__count" data-ref="count" aria-live="polite"></span>
            </div>
          </header>

          <div class="hnp__body">
            <div class="hnp__grid">${boxes.map((box) => this.tileTemplate(box)).join('')}</div>
          </div>

          <footer class="hnp__foot">
            <p class="hnp__sum">
              <span>Zwischensumme</span>
              <span><s class="hnp__sum-old" data-ref="sumBefore" hidden></s> <strong data-ref="sum"></strong></span>
            </p>
            <p class="hnp__sum-note" data-ref="sumNote"></p>
            <p class="hnp__note">${escapeHtml(texts.note || '')}</p>
            <button type="button" class="hnp__cta" data-ref="submit" disabled></button>

            <div class="hnp-abo" data-ref="abo" hidden>
              <label class="hnp-abo__switch">
                <input type="checkbox" role="switch" data-ref="aboToggle">
                <span class="hnp-abo__track" aria-hidden="true"><span class="hnp-abo__thumb"></span></span>
                <span class="hnp-abo__label">Als Abo bestellen<span class="hnp-abo__save" data-ref="aboSave"></span></span>
              </label>
              <div class="hnp-abo__interval" data-ref="aboInterval" hidden>
                <label for="hnp-abo-plan">Lieferung</label>
                <select id="hnp-abo-plan" data-ref="aboPlan"></select>
              </div>
              <p class="hnp-abo__hint" data-ref="aboHint"></p>
            </div>

            <p class="hnp__error" data-ref="error" role="alert"></p>
          </footer>
        </div>`;

      document.body.appendChild(this.overlay);
      this.dialog = this.overlay.querySelector('.hnp');

      // Alle Elemente mit data-ref als this.refs.<name> ablegen
      this.refs = {};
      this.overlay.querySelectorAll('[data-ref]').forEach((el) => { this.refs[el.dataset.ref] = el; });

      this.bindEvents();
    }

    tileTemplate(box) {
      const name = escapeHtml(box.name);
      const image = box.image ? `<img src="${escapeHtml(box.image)}" alt="" loading="lazy" width="360" height="360">` : '';
      const controls = box.available
        ? `<div class="hnp-step">
             <button type="button" class="hnp-step__btn" data-action="decrease" aria-label="${name}: eine Box weniger">&minus;</button>
             <span class="hnp-step__qty" data-qty>0</span>
             <button type="button" class="hnp-step__btn" data-action="increase" aria-label="${name}: eine Box mehr">+</button>
           </div>`
        : '<span class="hnp-tile__soldout">Gerade ausverkauft</span>';

      return `
        <div class="hnp-tile${box.available ? '' : ' is-soldout'}" data-variant-id="${box.variantId}">
          <button type="button" class="hnp-tile__media" data-action="increase" aria-label="${name} hinzufügen"${box.available ? '' : ' disabled'}>
            ${image}<span class="hnp-tile__badge" data-badge></span>
          </button>
          <p class="hnp-tile__name">${name}</p>
          ${controls}
        </div>`;
    }

    bindEvents() {
      this.overlay.addEventListener('click', (event) => {
        if (event.target === this.overlay) return this.close(); // Klick auf den Hintergrund

        const trigger = event.target.closest('[data-action]');
        if (!trigger || trigger.disabled) return;

        const action = trigger.dataset.action;
        if (action === 'close') return this.close();

        const tile = trigger.closest('.hnp-tile');
        if (tile) this.changeQuantity(Number(tile.dataset.variantId), action === 'increase' ? 1 : -1);
      });

      this.refs.submit.addEventListener('click', () => this.submit());

      this.refs.aboToggle.addEventListener('change', (event) => {
        this.state.subscribe = event.target.checked;
        this.render();
      });

      this.refs.aboPlan.addEventListener('change', (event) => {
        this.state.planId = Number(event.target.value);
        this.render();
      });

      document.addEventListener('keydown', (event) => {
        if (!this.isOpen()) return;
        if (event.key === 'Escape') this.close();
        if (event.key === 'Tab') this.trapFocus(event);
      });
    }

    /* ----- Öffnen / Schließen ----- */

    open(size, title, opener) {
      Object.assign(this.state, { size, quantities: new Map(), subscribe: false, planId: null, busy: false });
      this.refs.aboToggle.checked = false;
      this.refs.error.textContent = '';
      this.refs.eyebrow.textContent = `${title ? `${title} · ` : ''}${size} Boxen à 12 Riegel`;
      this.opener = opener || document.activeElement;
      this.render();

      this.overlay.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('hnp-lock');
      requestAnimationFrame(() => {
        this.overlay.classList.add('is-open');
        this.dialog.focus({ preventScroll: true });
      });
    }

    close() {
      this.overlay.classList.remove('is-open');
      this.overlay.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('hnp-lock');
      if (this.opener && this.opener.focus) this.opener.focus({ preventScroll: true });
    }

    isOpen() {
      return this.overlay.classList.contains('is-open');
    }

    trapFocus(event) {
      const focusable = [...this.dialog.querySelectorAll('button, select, input, [tabindex]:not([tabindex="-1"])')]
        .filter((el) => !el.disabled && el.offsetParent !== null);
      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }

    /* ----- Auswahl ----- */

    totalBoxes() {
      let total = 0;
      this.state.quantities.forEach((qty) => { total += qty; });
      return total;
    }

    changeQuantity(variantId, delta) {
      const { quantities, size } = this.state;
      if (delta > 0 && this.totalBoxes() >= size) return;

      const next = Math.max(0, (quantities.get(variantId) || 0) + delta);
      if (next) quantities.set(variantId, next);
      else quantities.delete(variantId);

      this.refs.error.textContent = '';
      this.render();
    }

    selectedBoxes() {
      return boxes.filter((box) => this.state.quantities.has(box.variantId));
    }

    /**
     * Welche Abo-Pläne stehen gerade zur Wahl?
     * - Noch nichts gewählt: alle Pläne, die die abo-fähigen Boxen gemeinsam haben.
     * - Sonst: nur Pläne, die jede gewählte Box hat. Ist eine Box ohne Abo dabei
     *   (z. B. Mango Limited Edition), ist das Abo gesperrt.
     */
    subscriptionOptions() {
      const selected = this.selectedBoxes();
      const withoutPlans = selected.filter((box) => !box.plans.length);
      const pool = (selected.length ? selected : boxes).filter((box) => box.plans.length);
      const plans = sharedPlans(pool);

      return {
        plans,
        withoutPlans,
        available: plans.length > 0 && withoutPlans.length === 0,
      };
    }

    selectedPlan(plans) {
      return plans.find((plan) => plan.id === this.state.planId) || null;
    }

    /* ----- Darstellung ----- */

    render() {
      const { state, refs } = this;
      const total = this.totalBoxes();
      const remaining = state.size - total;

      // Fortschritt
      this.dialog.classList.toggle('is-complete', remaining === 0);
      refs.progress.style.width = `${state.size ? (total / state.size) * 100 : 0}%`;
      refs.count.innerHTML = `<strong>${total}</strong> von ${state.size} Boxen`;

      // Kacheln
      this.overlay.querySelectorAll('.hnp-tile').forEach((tile) => {
        const box = boxes.find((b) => b.variantId === Number(tile.dataset.variantId));
        const qty = state.quantities.get(box.variantId) || 0;
        const canAdd = box.available && remaining > 0;

        tile.classList.toggle('is-selected', qty > 0);
        tile.querySelector('[data-badge]').textContent = `${qty}×`;
        tile.querySelector('.hnp-tile__media').disabled = !canAdd;

        const qtyEl = tile.querySelector('[data-qty]');
        if (qtyEl) qtyEl.textContent = qty;
        const decrease = tile.querySelector('.hnp-step__btn[data-action="decrease"]');
        if (decrease) decrease.disabled = qty === 0;
        const increase = tile.querySelector('.hnp-step__btn[data-action="increase"]');
        if (increase) increase.disabled = !canAdd;
      });

      // Abo + Summe
      const plan = this.renderSubscription();
      this.renderSum(plan);

      // Button
      refs.submit.disabled = remaining !== 0 || state.busy;
      if (state.busy) refs.submit.textContent = 'Wird hinzugefügt …';
      else if (remaining > 0) refs.submit.textContent = `Noch ${remaining} ${remaining === 1 ? 'Box' : 'Boxen'} wählen`;
      else refs.submit.textContent = `${state.size} ${state.size === 1 ? 'Box' : 'Boxen'} in den Warenkorb`;
    }

    /** Zeichnet den Abo-Bereich und gibt den aktiven Plan zurück (oder null). */
    renderSubscription() {
      const { state, refs } = this;

      if (!config.showSubscription) {
        refs.abo.hidden = true;
        return null;
      }

      const { plans, withoutPlans, available } = this.subscriptionOptions();
      refs.abo.hidden = plans.length === 0 && withoutPlans.length === 0;

      // Toggle sperren, wenn kein gemeinsamer Plan möglich ist
      refs.aboToggle.disabled = !available;
      if (!available) state.subscribe = false;
      refs.aboToggle.checked = state.subscribe;

      // „· 10 % sparen" aus dem Appstle-Rabatt
      const discount = Math.max(0, ...plans.map((p) => p.discountPercent || 0));
      refs.aboSave.textContent = discount ? ` · ${discount} % sparen` : '';

      refs.aboHint.textContent = withoutPlans.length
        ? `${withoutPlans.map((box) => box.name).join(', ')} gibt es nicht im Abo.`
        : '';

      // Dropdown mit den Appstle-Plänen (nur neu aufbauen, wenn sich die Auswahl ändert)
      const optionsKey = plans.map((p) => p.id).join(',');
      if (refs.aboPlan.dataset.key !== optionsKey) {
        refs.aboPlan.dataset.key = optionsKey;
        refs.aboPlan.innerHTML = plans
          .map((p) => `<option value="${p.id}">${escapeHtml(p.name)}</option>`)
          .join('');
      }
      if (!this.selectedPlan(plans)) state.planId = plans.length ? plans[0].id : null;
      refs.aboPlan.value = String(state.planId);

      refs.aboInterval.hidden = !state.subscribe;
      return state.subscribe ? this.selectedPlan(plans) : null;
    }

    /** Summe wie im Warenkorb (siehe priceBreakdown) inkl. Hinweis, welche Rabatte drin sind. */
    renderSum(plan) {
      const { refs, state } = this;
      const aboPercent = plan ? plan.discountPercent || 0 : 0;
      const code = activeDiscountCode();
      const codeApplies = code && !plan; // Codes gelten nur für einmalige Käufe

      const lines = this.selectedBoxes().map((box) => ({ price: box.price, quantity: state.quantities.get(box.variantId) }));
      const { fullPrice, total, volumePercent } = priceBreakdown(lines, {
        boxCount: state.size,
        aboPercent,
        codePercent: codeApplies ? code.percent : 0,
      });

      refs.sum.textContent = formatMoney(total);
      refs.sumBefore.hidden = !(total < fullPrice);
      refs.sumBefore.textContent = formatMoney(fullPrice);

      const savings = [];
      if (codeApplies) savings.push(`${code.percent} % ${code.code}`);
      if (volumePercent) savings.push(`${volumePercent} % Mengenrabatt`);
      if (aboPercent) savings.push(`${aboPercent} % Abo-Rabatt`);
      let note = savings.length ? `inkl. ${savings.join(' + ')}` : '';
      if (code && plan) note += ` · ${code.code} gilt nur für Einmalkäufe`;
      refs.sumNote.textContent = note;
    }

    /* ----- In den Warenkorb ----- */

    async submit() {
      const { state, refs } = this;
      if (state.busy || this.totalBoxes() !== state.size) return;

      const plan = state.subscribe ? this.selectedPlan(this.subscriptionOptions().plans) : null;
      const items = this.selectedBoxes().map((box) => {
        const item = { id: box.variantId, quantity: state.quantities.get(box.variantId) };
        if (plan) item.selling_plan = plan.id; // Appstle-Abo
        return item;
      });

      state.busy = true;
      this.render();
      try {
        await Cart.add(items);
        state.busy = false;
        this.close();
        Cart.open();
      } catch (error) {
        state.busy = false;
        this.render();
        refs.error.textContent = error.message;
      }
    }
  }

  let picker = null;
  function openPicker(size, title, opener) {
    if (!boxes.length) {
      console.warn('[HiNUtS Pack] In der Section sind keine Boxen hinterlegt.');
      return;
    }
    picker = picker || new PackPicker();
    picker.open(size, title, opener);
  }

  /* ---------------------------------------------------------------------------
   * 5. Produktkarten (überall, wo das Theme .product-item-Karten zeigt)
   *    Preis: Packs & Boxen zeigen den Preis wie im Warenkorb (Mengenrabatt,
   *           Rabattcode aus Link) inkl. Streichpreis und Badge.
   *    Button „In den Warenkorb" (nur wo in der Section eingeschaltet):
   *      - normale Box    → direkt in den Warenkorb
   *      - Pack (pack-N)  → Popup
   *      - Bundle-Builder → Produktseite („Zusammenstellen")
   * ------------------------------------------------------------------------ */

  const CART_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2.5 3.5h2.2l2.1 11.1a1.6 1.6 0 0 0 1.6 1.3h8.4a1.6 1.6 0 0 0 1.6-1.2l1.3-6.2H8"/><circle cx="9.5" cy="20" r="1.4"/><circle cx="17" cy="20" r="1.4"/><circle cx="18.6" cy="5.4" r="3.9" fill="currentColor" stroke="none"/><path d="M18.6 3.6v3.6M16.8 5.4h3.6" stroke="var(--hnp-teal, #41bdad)" stroke-width="1.6"/></svg>';
  const CHECK_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';

  /** Icon-Button: Symbol zeigen, Bedeutung als Beschriftung für Screenreader und Tooltip. */
  function setButtonState(button, state, label) {
    button.innerHTML = state === 'added' ? CHECK_ICON : CART_ICON;
    button.setAttribute('aria-label', label);
    button.title = label;
  }

  const ProductCards = {
    label: texts.cardButton || 'In den Warenkorb',

    init() {
      this.scan();
      if (config.cardButtons) document.addEventListener('click', (event) => this.onClick(event), true);

      // Filter, Sortierung und Paginierung tauschen das Raster per AJAX aus
      let timer;
      new MutationObserver(() => {
        clearTimeout(timer);
        timer = setTimeout(() => this.scan(), 120);
      }).observe(document.body, { childList: true, subtree: true });
    },

    /** Neue Karten finden, Handle merken, ggf. Button einfügen. */
    scan() {
      document.querySelectorAll('.product-item:not([data-hnp-ready])').forEach((card) => {
        card.dataset.hnpReady = 'true';
        const link = card.querySelector('a[href*="/products/"]');
        const match = link && /\/products\/([^/?#]+)/.exec(link.getAttribute('href'));
        if (!match) return;
        card.dataset.hnpHandle = decodeURIComponent(match[1]);

        card.classList.add('hnp-card');
        this.splitTitle(card);

        // Warenkorb-Icon unten rechts im Bild (weiße Ecke wie bei MORE)
        const media = card.querySelector('.product-item__media');
        if (config.cardButtons && media) {
          const wrap = document.createElement('span');
          wrap.className = 'hnp-card-atc-wrap';
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'hnp-card-atc';
          button.dataset.handle = card.dataset.hnpHandle;
          setButtonState(button, 'default', this.label);
          wrap.appendChild(button);
          media.appendChild(wrap);
        }

        this.prepare(card);
      });
    },

    /** „HiNUtS Erdnuss (12 Riegel)" → fett „HiNUtS Erdnuss", grau darunter „12 Riegel". */
    splitTitle(card) {
      const title = card.querySelector('.product-item__product-title');
      if (!title || title.querySelector('.hnp-card-subtitle')) return;
      const match = /^(.*?)\s*\(([^)]+)\)\s*$/.exec(title.textContent.trim());
      if (!match) return;
      title.textContent = match[1];
      const sub = document.createElement('span');
      sub.className = 'hnp-card-subtitle';
      sub.textContent = match[2];
      title.appendChild(sub);
    },

    /** Preis, Badge und Button-Beschriftung setzen (Produktdaten werden zwischengespeichert). */
    async prepare(card) {
      try {
        const product = await Cart.getProduct(card.dataset.hnpHandle);
        const button = card.querySelector('.hnp-card-atc');
        const packSize = packSizeFromTags(product.tags);
        const isBox = boxes.some((box) => box.handle === product.handle);

        if (packSize) {
          // Packs haben absichtlich keinen Lagerbestand → „Ausverkauft"-Badge ausblenden
          card.querySelectorAll('.product-badges *').forEach((el) => {
            if (!el.children.length && /ausverkauft|sold out/i.test(el.textContent)) {
              (el.closest('.product-badges > *') || el).style.display = 'none';
            }
          });
        }

        if (packSize || isBox) {
          card.hnpBoxCount = packSize || 1; // für spätere Aktualisierung merken
          this.showPrice(card);
        } else if (button && isBundleBuilder(product)) {
          setButtonState(button, 'default', 'Zusammenstellen');
        } else if (button && !product.variants.some((variant) => variant.available)) {
          button.disabled = true;
          setButtonState(button, 'default', 'Ausverkauft');
        }
      } catch (error) { /* Karte bleibt einfach wie sie ist */ }
    },

    /**
     * Preis auf der Karte so zeigen, wie er im Warenkorb herauskommt:
     * Streichpreis = voller Preis der Boxen, Endpreis = nach Rabattcode + Mengenrabatt.
     * Badge oben links im Bild: Gesamtrabatt, z. B. „−18%".
     */
    showPrice(card) {
      const boxCount = card.hnpBoxCount;
      const button = card.querySelector('.hnp-card-atc');
      const priceBox = card.querySelector('.product-item__price');
      const perBar = card.querySelector('[data-price-per-bar]');
      const perKg = card.querySelector('[data-unit-price]');

      // Beim ersten Mal den Originalzustand des Themes merken, danach immer davon ausgehen –
      // so lässt sich die Karte neu zeichnen, wenn der Code wechselt oder entfernt wird.
      if (!card.hnpOriginal) {
        card.hnpOriginal = {
          price: priceBox ? priceBox.innerHTML : null,
          perBar: perBar ? perBar.textContent : null,
          perKg: perKg ? perKg.textContent : null,
        };
      } else {
        if (priceBox && card.hnpOriginal.price !== null) priceBox.innerHTML = card.hnpOriginal.price;
        if (perBar && card.hnpOriginal.perBar !== null) perBar.textContent = card.hnpOriginal.perBar;
        if (perKg && card.hnpOriginal.perKg !== null) perKg.textContent = card.hnpOriginal.perKg;
      }
      card.querySelectorAll('.hnp-card-badge').forEach((badge) => badge.remove());
      const discountLabel = card.querySelector('.displayed-discount');

      const code = activeDiscountCode();
      const { fullPrice, total, volumePercent, totalPercent } = priceBreakdown(
        [{ price: boxPrice, quantity: boxCount }],
        { boxCount, codePercent: code ? code.percent : 0 }
      );
      const markEmpty = () => {
        if (discountLabel) discountLabel.classList.toggle('is-empty', !discountLabel.textContent.trim());
      };
      if (!totalPercent) return markEmpty(); // einzelne Box ohne Code: nichts zu tun

      // Rabatt-Badge oben links im Bild, z. B. „−28%"
      const badge = document.createElement('span');
      badge.className = 'hnp-card-badge';
      badge.textContent = `−${totalPercent}%`;
      badge.title = code ? `inkl. Code ${code.code}${volumePercent ? ' und Mengenrabatt' : ''}` : 'Mengenrabatt';
      const badgeBar = card.querySelector('.product-badges');
      if (badgeBar) badgeBar.prepend(badge);
      else {
        badge.classList.add('hnp-card-badge--floating');
        (card.querySelector('.product-item__media') || card).appendChild(badge);
      }

      if (!code) return markEmpty(); // ohne Code stimmt der Preis aus Shopify bereits

      // Preis des Themes überschreiben: Streichpreis + Endpreis
      const current = card.querySelector('.product-item__price .sale, span.product-item__price');
      if (!current) return;
      let strike = card.querySelector('.product-item__price s');
      if (!strike) {
        strike = document.createElement('s');
        strike.className = 't-subdued';
        current.before(strike, ' ');
      }
      strike.textContent = formatMoney(fullPrice);
      current.textContent = formatMoney(total);
      current.classList.add('sale');

      if (discountLabel) discountLabel.textContent = `-${totalPercent}%`;
      markEmpty();

      // Preis pro Riegel / kg (12 Riegel à 50 g pro Box)
      const bars = boxCount * 12;
      if (perBar) perBar.textContent = formatMoney(total / bars);
      if (perKg) perKg.textContent = formatMoney(total / (bars * 50) * 1000);
    },

    /** Alle Box- und Pack-Karten neu zeichnen (nach Codewechsel). */
    rerender() {
      document.querySelectorAll('.product-item').forEach((card) => {
        if (card.hnpBoxCount) this.showPrice(card);
      });
    },

    async onClick(event) {
      const button = event.target.closest && event.target.closest('.hnp-card-atc');
      if (!button) return;
      event.preventDefault();
      event.stopPropagation();
      if (button.disabled || button.classList.contains('is-loading')) return;

      button.classList.add('is-loading');
      try {
        const product = await Cart.getProduct(button.dataset.handle);
        const packSize = packSizeFromTags(product.tags);
        const variant = product.variants.find((v) => v.available);
        const needsProductPage = isBundleBuilder(product) || product.variants.length > 1 || product.requires_selling_plan;

        if (packSize) {
          openPicker(packSize, product.title, button);
        } else if (needsProductPage) {
          window.location.href = product.url;
        } else if (!variant) {
          button.disabled = true;
          setButtonState(button, 'default', 'Ausverkauft');
        } else {
          await Cart.add([{ id: variant.id, quantity: 1 }]);
          button.classList.add('is-added');
          setButtonState(button, 'added', 'Hinzugefügt');
          Cart.open();
          setTimeout(() => {
            button.classList.remove('is-added');
            setButtonState(button, 'default', this.label);
          }, 2200);
        }
      } catch (error) {
        alert(error.message || 'Das hat leider nicht geklappt.');
      } finally {
        button.classList.remove('is-loading');
      }
    },
  };

  /* ---------------------------------------------------------------------------
   * 6. Produktseite einer Box oder eines Packs
   *    - Preis wie im Warenkorb (Rabattcode aus Link, Mengenrabatt, Preis pro Riegel)
   *    - nur Packs: Warenkorb-Button öffnet das Popup statt das Pack zu kaufen.
   *      Packs haben bewusst keinen Lagerbestand – das Theme würde sie sonst als
   *      „Ausverkauft" sperren. Deshalb schalten wir den Button hier wieder frei.
   * ------------------------------------------------------------------------ */

  const ProductPage = {
    init() {
      const isBox = boxes.some((box) => box.handle === config.pageHandle);
      this.packSize = config.packSizeOnPage || 0;
      this.boxCount = this.packSize || (isBox ? 1 : 0);
      if (!this.boxCount) return;

      this.label = texts.cardButton || 'In den Warenkorb';
      if (this.packSize) this.interceptAddToCart();

      this.sync();
      let scheduled = false;
      new MutationObserver(() => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(() => { scheduled = false; this.sync(); });
      }).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
    },

    /** Capture-Phase: wir sind vor dem Theme dran und stoppen dessen Warenkorb-Logik. */
    interceptAddToCart() {
      const title = config.pageProduct ? config.pageProduct.title : '';

      document.addEventListener('click', (event) => {
        const button = event.target.closest && event.target.closest('[data-add-to-cart], button[type="submit"][name="add"]');
        if (!button || !this.isPageForm(button.form || button.closest('form'))) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        openPicker(this.packSize, title, button);
      }, true);

      document.addEventListener('submit', (event) => {
        if (!this.isPageForm(event.target)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        openPicker(this.packSize, title, null);
      }, true);
    },

    isPageForm(form) {
      return Boolean(form && form.matches && form.matches('form[data-product-form]')) &&
        (!form.dataset.productHandle || form.dataset.productHandle === config.pageHandle);
    },

    /** Wird bei jeder DOM-Änderung erneut aufgerufen, setzt aber nur, was abweicht. */
    sync() {
      if (!this.boxCount) return;
      // Originaltexte des Themes merken, bevor wir sie überschreiben – damit sie zurückkommen,
      // wenn der Kunde den Code im Warenkorb entfernt.
      this.originals = this.originals || new Map();
      const setText = (selector, value) => {
        const el = document.querySelector(selector);
        if (!el) return el;
        if (!this.originals.has(el)) this.originals.set(el, { text: el.textContent, display: el.style.display });
        if (el.textContent.trim() !== value) el.textContent = value;
        return el;
      };
      const restore = (selector) => {
        const el = document.querySelector(selector);
        const original = el && this.originals.get(el);
        if (!original) return;
        if (el.textContent !== original.text) el.textContent = original.text;
        if (el.style.display !== original.display) el.style.display = original.display;
      };

      // Pack: Button freischalten und beschriften
      if (this.packSize) {
        document.querySelectorAll('form[data-product-form] [data-add-to-cart], .sticky-atc-bar [data-add-to-cart]').forEach((button) => {
          if (button.disabled) button.disabled = false;
          if (button.hasAttribute('aria-disabled')) button.removeAttribute('aria-disabled');
          if (button.getAttribute('aria-label') !== this.label) button.setAttribute('aria-label', this.label);
          const text = button.querySelector('[data-add-to-cart-text]');
          if (text && text.textContent.trim() !== this.label) text.textContent = this.label;
        });
      }

      const code = activeDiscountCode();
      const { fullPrice, total, totalPercent } = priceBreakdown(
        [{ price: boxPrice, quantity: this.boxCount }],
        { boxCount: this.boxCount, codePercent: code ? code.percent : 0 }
      );

      // Mit Code: Endpreis, Streichpreis und Prozent wie im Warenkorb
      if (code) {
        setText('.product__price [data-price]', formatMoney(total));
        setText('.product__price [data-compare-price]', formatMoney(fullPrice));
        setText('.product__price [data-discount-display]', `-${totalPercent}%`);
        setText('[data-standard-pack-custom-price-current]', formatMoney(total));
        const original = setText('[data-standard-pack-custom-price-original]', formatMoney(fullPrice));
        if (original && original.style.display === 'none') original.style.display = '';
      } else {
        // Kein Code (mehr): Theme-Anzeige wiederherstellen
        ['.product__price [data-price]', '.product__price [data-compare-price]', '.product__price [data-discount-display]',
          '[data-standard-pack-custom-price-current]', '[data-standard-pack-custom-price-original]'].forEach(restore);
      }

      // Preis pro Riegel / kg (das Theme rechnet fix mit 12 Riegeln)
      if (code || this.packSize) {
        const bars = this.boxCount * 12;
        setText('[data-standard-pack-custom-price-per-unit]',
          `${formatMoney(total / bars)}/Riegel · ${formatMoney(total / (bars * 50) * 1000)}/kg`);
      } else {
        restore('[data-standard-pack-custom-price-per-unit]');
      }
    },
  };

  /* ---------------------------------------------------------------------------
   * 7. Sale-Code für alle + Hinweisleiste „Rabattcode aktiv" (wie bei MORE)
   *
   * Sale-Code: Wer ohne eigenen Code kommt, bekommt den Sale-Code (z. B.
   * BLACKWEEK) einmal automatisch in Warenkorb + Cookie. Kommt später ein
   * Code-Link (TRY15, HI-…), setzt Shopify den neuen Code – der gilt dann, denn
   * Codes untereinander sind nicht kombinierbar. Entfernt der Kunde den
   * Sale-Code im Warenkorb, setzen wir ihn nicht erneut (Merker im Browser).
   * ------------------------------------------------------------------------ */

  const SaleCode = {
    init() {
      if (!saleCode) return;
      const storageKey = `hnp-sale-code-${saleCode.code}`;
      const hasCode = /(?:^|;\s*)discount_code=[^;]+/.test(document.cookie);
      if (hasCode || this.read(storageKey)) return;

      // Cookie sofort setzen, damit Preise und Leiste schon beim ersten Laden stimmen
      document.cookie = `discount_code=${encodeURIComponent(saleCode.code)}; path=/; max-age=${60 * 60 * 24 * 14}; SameSite=Lax`;
      this.write(storageKey, '1');

      // Code auch am Warenkorb hinterlegen – dort sieht und ändert ihn der Kunde
      return fetch(`${ROOT}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: saleCode.code }),
      }).catch(() => { /* Code steht trotzdem im Cookie und wird an der Kasse übernommen */ });
    },

    read(key) {
      try { return window.localStorage.getItem(key); } catch (error) { return null; }
    },

    write(key, value) {
      try { window.localStorage.setItem(key, value); } catch (error) { /* privates Fenster o. Ä. */ }
    },
  };

  /**
   * Hinweis „Code aktiviert" wie bei MORE: eine helle Box direkt über den Produkten
   * (Kollektionsseite) bzw. unter dem Preis (Produktseite) – nicht mehr als Leiste im Header.
   */
  const CodeBanner = {
    init() {
      this.render();
    },

    /** Wo die Box hinkommt: { parent, before } oder null (dann keine Box auf dieser Seite). */
    placement() {
      const heroInner = document.querySelector('.hch__inner');
      if (heroInner) return { parent: heroInner, before: null };

      const grid = document.querySelector('.collection__main-area, .collection__products');
      if (grid) return { parent: grid.parentNode, before: grid };

      const price = document.querySelector('[data-standard-pack-custom-price-section]:not([hidden])') ||
        [...document.querySelectorAll('.product__price-and-ratings, [data-standard-pack-custom-price-section]')]
          .find((el) => getComputedStyle(el).display !== 'none');
      if (price) {
        const block = price.closest('.product__block') || price;
        return { parent: block.parentNode, before: block.nextSibling };
      }
      return null;
    },

    /** Box (neu) zeichnen – auch nach Codewechsel im Warenkorb, ohne Neuladen. */
    render() {
      document.querySelectorAll('.hnp-code-box, .hnp-code-banner').forEach((box) => box.remove());
      if (!config.codeBanner || !config.codeBanner.show) return;

      // Jeder gültige Code wird angezeigt – auch ohne bekannten Prozentsatz (dann ohne Zusatztext).
      const known = activeDiscountCode();
      const code = known ? known.code : codeState.codes()[0];
      if (!code) return;

      const spot = this.placement();
      if (!spot) return;

      const fill = (template) => escapeHtml(template || '')
        .replace(/\{code\}/g, escapeHtml(code))
        .replace(/\{percent\}/g, known ? String(known.percent) : '');
      const title = fill(config.codeBanner.title || 'Code „{code}“ aktiviert');
      const detail = known ? fill(config.codeBanner.text) : '';

      const box = document.createElement('div');
      box.className = 'hnp-code-box';
      box.setAttribute('role', 'status');
      box.innerHTML = `
        <svg class="hnp-code-box__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="1.8"></circle>
          <path d="M12 10.5v6" stroke="currentColor" stroke-width="2" stroke-linecap="round"></path>
          <circle cx="12" cy="7.3" r="1.25" fill="currentColor"></circle>
        </svg>
        <p class="hnp-code-box__text"><strong>${title}</strong>${detail ? ` <span>${detail}</span>` : ''}</p>`;
      spot.parent.insertBefore(box, spot.before);
    },
  };

  /* ---------------------------------------------------------------------------
   * 8. Start
   * ------------------------------------------------------------------------ */

  /** Nach einem Codewechsel: Leiste, Karten, Produktseite und offenes Popup neu zeichnen. */
  function rerenderAll() {
    CodeBanner.render();
    ProductCards.rerender();
    ProductPage.sync();
    if (picker && picker.isOpen()) picker.render();
  }

  /**
   * Codewechsel ohne Neuladen erkennen. Der Kaching-Warenkorb meldet keine Ereignisse
   * und seine Anfragen lassen sich nicht abfangen – deshalb prüfen wir den Warenkorb
   * kurz nach jeder Interaktion erneut (nur wenn sich etwas ändert, wird neu gezeichnet).
   */
  const LiveCode = {
    init() {
      let timers = [];
      const schedule = () => {
        timers.forEach(clearTimeout);
        timers = [800, 2500, 6000, 12000].map((delay) => setTimeout(() => codeState.refresh(), delay));
      };
      document.addEventListener('click', schedule, true);
      document.addEventListener('keyup', (event) => { if (event.key === 'Enter') schedule(); }, true);
      document.addEventListener('change', schedule, true);
      window.addEventListener('focus', () => codeState.refresh());
      window.addEventListener('pageshow', (event) => { if (event.persisted) codeState.refresh(); });
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') codeState.refresh();
      });
      // Kaching rendert in einem iframe: Klicks dort erreichen unser document nicht,
      // der Fokuswechsel ins iframe aber schon.
      window.addEventListener('blur', schedule);
    },
  };

  window.HinutsPack = { open: openPicker, refreshCode: () => codeState.refresh() };

  async function init() {
    await SaleCode.init();  // setzt ggf. den Sale-Code (nur wenn in der Section eingetragen)
    await codeState.load(); // welcher Code gilt laut Warenkorb? Danach richten sich alle Preise
    CodeBanner.init();
    ProductCards.init();
    ProductPage.init();
    LiveCode.init();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
